import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';

export const backupFilesColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('backupRestore.grid.filename'),
    field: 'filename',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('backupRestore.grid.app'),
    field: 'product',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('backupRestore.grid.creationTime'),
    field: 'creationOn',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
];

export const backupTasksColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('backupRestore.grid.name'),
    field: 'name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'procName',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('backupRestore.grid.product'),
    field: 'product',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'paramName',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('backupRestore.grid.type'),
    field: 'case.type',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'paramValue',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('backupRestore.grid.start_time'),
    field: 'start_time',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'paramValue',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('backupRestore.grid.completion_time'),
    field: 'completion_time',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'paramValue',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('backupRestore.grid.status'),
    field: 'status',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'paramValue',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  }
];
